import React from 'react';
import { observer } from 'mobx-react';
import { GridItemStore } from '@seedlang/stores';
import TypeAhead from 'components/type_ahead';
import { isEmpty } from 'lodash';

@observer
class GridItemSearch extends React.Component {

  static defaultProps = {
    searchByField: 'name',
    placeholder: 'Search for Grid Section',
  };

  constructor(props) {
    super(props);
    this.onClear();
  }

  componentWillUnmount() {
    this.onClear();
  }

  onKeyUp(value) {
    if (isEmpty(value)) {
      this.onClear();
    } else {
      GridItemStore.setFilter(this.props.searchByField, `~${value}~`, { refresh: true });
    }
  }

  onSelect(obj) {
    this.props.onSubmit(obj);
  }

  onClear() {
    GridItemStore.clearIndexData();
    GridItemStore.clearFilter();
    GridItemStore.setFilter('slug', 'false');
  }

  render() {
    return (
      <div className='concept-search'>
        <TypeAhead
          onKeyUp={this.onKeyUp.bind(this)}
          onSelect={this.onSelect.bind(this)}
          onClear={this.onClear.bind(this)}
          options={GridItemStore.indexData}
          displayField={this.props.displayField || this.props.searchByField}
          placeholder={this.props.placeholder}
        />
      </div>
    );
  }
}

export default GridItemSearch;
